/* eslint-disable react/jsx-no-target-blank */

import { useState } from 'react'
import { cx } from '@/utils/strings'
import Routes from '@/constants/routes'

function SocialShare(props) {
  const { slug, title } = props

  const [copied, setCopied] = useState(false)
  const [hide, setHide] = useState(true)

  const handleTransitionEnd = () => {
    if (!copied) {
      setHide(true)
    }
  }

  const roundedLinkStyle = 'rounded-full h-8 w-8 bg-primaryBlue block flex justify-center items-center dark:bg-white'

  const socialLinks = [
    {
      url: 'https://twitter.com/share?url=',
      ariaLabel: 'Twitter',
      linkTitle: 'Tweet',
      unicode: '\ue961',
    },
    {
      url: 'https://www.facebook.com/sharer/sharer.php?u=',
      ariaLabel: 'Facebook',
      linkTitle: 'Facebook',
      unicode: '\ue94d',
    },
    {
      url: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      ariaLabel: 'LinkedIn',
      linkTitle: 'LinkedIn',
      unicode: '\ue955',
    },
    {
      url: `mailto:?subject=${encodeURIComponent(title)}&body=`,
      ariaLabel: 'Email',
      linkTitle: 'Email',
      unicode: '\ue949',
    },
  ]

  const renderSocialLink = (link) => {
    const { url, ariaLabel, linkTitle, unicode } = link
    const linkPath = `${url}${Routes.hostname}${slug}`
    return (
      <a
        href={linkPath}
        key={linkTitle}
        aria-label={ariaLabel}
        target="_blank"
        rel="noopener noreferrer"
        title={linkTitle}
        onClick={() =>
          linkTitle !== 'Email' &&
          window.open(
            linkPath,
            '',
            '_blank, width=500, height=600, menubar=no, toolbar=no, resizable=yes, scrollbars=yes'
          )
        }
        className={cx(roundedLinkStyle)}
      >
        <span className="text-white dark:text-secondary-800 font-bwi">{unicode}</span>
      </a>
    )
  }

  return (
    <div className="flex space-x-2">
      {socialLinks.map((link) => renderSocialLink(link))}
      <div className="relative">
        <button
          className={cx(roundedLinkStyle)}
          type="button"
          title="Copy Link"
          aria-label="Copy Link"
          onClick={() => {
            setHide(false)
            navigator.clipboard.writeText(window.location.href)
            setCopied(true)
            setTimeout(() => {
              setCopied(false)
            }, 3000)
          }}
        >
          <span className="text-white dark:text-secondary-800 font-bwi">&#xe954;</span>
        </button>
        <div
          onTransitionEnd={handleTransitionEnd}
          className={cx(
            'absolute -left-4 -bottom-8 py-1 px-2 transition-all duration-500 ease-in-out rounded-sm text-sm text-white bg-primaryBlue whitespace-nowrap',
            copied ? 'z-50 w-auto scale-100 opacity-100' : 'scale-0 opacity-0',
            hide ? 'hidden' : 'block'
          )}
        >
          Link Copied!
        </div>
      </div>
    </div>
  )
}

export default SocialShare
